import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CareersPlan, Course } from "app/main/careers/models/career";
import Swal from "sweetalert2";

export interface Plan {
  planName: string;
  planId: number;
  amount: number;
  hasDiscount: boolean;
  discountedAmount: number;
}

@Component({
  standalone: false,
  selector: "app-provide-subscription-plan",
  templateUrl: "./provide-subscription-plan.component.html",
  styleUrls: ["./provide-subscription-plan.component.scss"],
})
export class ProvideSubscriptionPlanComponent implements OnInit, OnChanges {
  @Input() isLoading: boolean = true;
  @Input() plans: Plan[] = [];
  @Input() careersPlans?: CareersPlan;
  careerPlans?: CareersPlan;

  @Output() planEvt: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadHomepageEvt: EventEmitter<any> = new EventEmitter<any>();
  @Output() phoneNumberEvt: EventEmitter<any> = new EventEmitter<any>();

    planForm: UntypedFormGroup;

  submitted = false;
  showDiscountField = false;

  selectedPlanIndex: any;
  alertClose = true;
  selectedCareerTopicIndex: number;
  unpaidCareerTopics: Course[];
  courseId: number;
  discountCode: string;

  // discount
  @Output() discountAppliedEvt = new EventEmitter<string>();
  @ViewChild('discountModal') discountModal: TemplateRef<any>;
  discountForm: UntypedFormGroup;
  private modalRef: NgbModalRef;

  constructor(private formBuilder: UntypedFormBuilder, private ngbModel: NgbModal, private route: ActivatedRoute, private modalService: NgbModal) {}
  ngOnChanges(changes: SimpleChanges): void {
    // console.warn(changes)
    if (changes?.careersPlans?.currentValue) {
      this.careerPlans = changes?.careersPlans?.currentValue
      // console.warn(changes.careerPlans)
      this.filterUnpaidCareerCourses();
    }
  }

  ngOnInit(): void {
    this.courseId = this.route.snapshot.queryParams.course;
    this.initForm();
    this.selectedPlanIndex = 0;
    this.initDiscountForm();
  }

  // initForm(){
  //   this.planForm = this.formBuilder.group({
  //     plan:["",[Validators.required]]
  //   });
  // }
  //
  // get f(){
  //   return this.planForm.controls;
  // }

  filterUnpaidCareerCourses(): void {
    if (this.careerPlans?.courses?.length) {
      // check if the subscription was initiated from mobile
      if(this.courseId != null || this.courseId != undefined) {
        this.selectedPlanIndex = this.careerPlans.courses?.find(topic => topic?.topicId == this.courseId);
        console.log("mobile",this.selectedPlanIndex)
      } else {
        this.selectedPlanIndex = this.careerPlans.courses?.find(topic => topic?.topicId == this.route.snapshot.queryParams.careerTopicId);
      }
      this.unpaidCareerTopics = this.careerPlans?.courses?.filter(
        (topic) => topic.subscribed === false
      );
    }
  }

  submitPlan() {
    this.submitted = true;
    if (this.planForm.invalid) return;

    const plan = this.planForm.value.plan;
    this.planEvt.emit(plan);
  }

  loadHomepage() {
    this.loadHomepageEvt.emit();
  }

  phoneForm: UntypedFormGroup;
  enablePhoneEdit = true;

  initForm() {
    this.phoneForm = this.formBuilder.group({
      phone: [
        null,
        [
          Validators.required,
          Validators.pattern("[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12),
        ],
      ],
    });
  }

  initDiscountForm() {
    this.discountForm = this.formBuilder.group({
      discountCode: ['']
    });
  }

  get f() {
    return this.phoneForm.controls;
  }

  setSelectedPlan(index: number) {
    this.selectedPlanIndex = index;
    this.alertClose = true;
  }

  submitPhoneNumber() {
    this.submitted = true;
    // if((this.selectedPlanIndex+"") == ""){
    //     this.alertClose = false;
    // }

    // if(this.phoneForm.invalid || (this.selectedPlanIndex+"") == "") return;

    if (this.phoneForm.invalid) return;

    this.alertClose = true;
    const phone: any = this.phoneForm.value.phone;

    const emitData: any = {
      phone: phone,
      planIndex: this.selectedPlanIndex?.topicId ?? this.selectedPlanIndex,
    };

    if (this.discountCode && this.discountCode.trim() !== '') {
      emitData.discountCode = this.discountCode;
    }
    this.phoneNumberEvt.emit(emitData);
  }

  toggleEnablePhoneEdit() {
    this.enablePhoneEdit = !this.enablePhoneEdit;
  }

  applyDiscountCode(): void {
    this.phoneForm.addControl('discountCode', this.formBuilder.control('', Validators.required));
    this.showDiscountField = true;
  }

  removeDiscountCode(): void {
    this.phoneForm.removeControl('discountCode');
    this.showDiscountField = false;
  }

  // discount modal
  openDiscountModal(): void {
    this.modalRef = this.modalService.open(this.discountModal, {centered: true});
  }

  applyDiscount(modal: NgbModalRef): void {
    this.discountCode = this.discountForm.get('discountCode').value;
    this.discountAppliedEvt.emit(this.discountCode);
    modal.close();
  }

}
